import React from "react";
import { FormGroup, Col, Row, Container, Button } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";

import { CustomInput } from "components";
import {
	matchesPasswordRegex,
	maxLength20,
	minLength8,
	passwordConfirmation,
	required,
	requiredWithMessage,
} from "validators/validation";

import { ReactComponent as Logo } from "static/images/logo.svg";
import { ReactComponent as CrmLogo } from "static/images/riseCrm.svg";
import styles from "./resetPassword.module.scss";

const passwordMessage =
	"Must contain at least 1 lowercase and 1 uppercase letters, 1 digit and 1 special character";

let ResetPasswordPageForm = ({ handleSubmit, cancelClick }) => {
	return (
		<Container>
			<Row className={styles.login}>
				<Col
					className={styles.loginBlock + " align-self-center"}
					md={{ span: 8, offset: 2 }}
				>
					<Col md={{ span: 8, offset: 2 }}>
						<div className={styles.logosHolder}>
							<Logo className={styles.mainLogo} />
							<CrmLogo className={styles.secondaryLogo} />
						</div>
						<div className={styles.welcomBlock}>
							<span className={styles.welcomeText}>
								<h2>
									<b>Forgot Password</b>
								</h2>
								<div>
									Use the instructions to create a new
									password.
								</div>
							</span>
						</div>
						<div className={styles.loginForm}>
							<form onSubmit={handleSubmit}>
								<FormGroup className={styles.password}>
									<Field
										type="password"
										component={CustomInput}
										validate={[
											requiredWithMessage(
												passwordMessage,
											),
											minLength8,
											maxLength20,
											matchesPasswordRegex,
										]}
										label="New Password"
										placeholder="Enter your new password"
										name="password"
										smSelect={12}
										smLabel={12}
									/>
								</FormGroup>

								<FormGroup>
									<Field
										type="password"
										component={CustomInput}
										validate={[
											required,
											passwordConfirmation,
										]}
										label="Confirm New Password"
										placeholder="Re-enter your new password"
										name="confirmPassword"
										smSelect={12}
										smLabel={12}
									/>
								</FormGroup>
								<FormGroup className="text-center">
									<Button
										onClick={cancelClick}
										variant="secondary"
										className={styles.cancelBtn}
									>
										CANCEL
									</Button>
									<Button
										type="submit"
										className={styles.okBtn}
									>
										OK
									</Button>
								</FormGroup>
							</form>
							<div className="col-md-12 text-center hidden">
								<a className={styles.supportLink} href="#?">
									Need help? Call us at 1-833-AURORA2
								</a>
							</div>
						</div>
					</Col>
				</Col>
			</Row>
		</Container>
	);
};

ResetPasswordPageForm = reduxForm({
	form: "resetPasswordForm",
})(ResetPasswordPageForm);

export { ResetPasswordPageForm };
